/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { Routes, RouterModule } from '@angular/router';
import { HistoricalAlarmListComponent } from './alarmList/historical-alarm-list.component';
import { PendingAlarmListComponent } from './alarmList/pending-alarm-list.component';


const routes: Routes = [
  { 
      path: 'alarms',
      children:[
          { path: 'historical' , component: HistoricalAlarmListComponent },
          { path: 'pending' , component: PendingAlarmListComponent }
      ]
  }
];

export const ALARM_ROUTES = RouterModule.forChild(routes);